import { createSlice } from "@reduxjs/toolkit";
import { BancoModel } from "../../../models/banco/bancoModel";
import { buscarBanco} from "../../../services/bancoService";
import { resetAll } from "../../actions/actions";

export interface BancoState {
  //buscar banco
  loading: boolean;
  busca: string | null;
  list: BancoModel[];
  entity: BancoModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: BancoState = {
  loading: false,
  busca: null,
  list: [],
  entity: {} as BancoModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const bancoSlice = createSlice({
  name: "banco",
  initialState,
  reducers: {
    //buscar banco
    setBuscaBanco: (state, action) => {
      state.busca = action.payload;
    },
    setEntityBanco: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarBanco: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarBanco: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar banco
    builder.addCase(buscarBanco.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarBanco.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarBanco.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar banco
  setBuscaBanco,
  setEntityBanco,
  //internal
  setModalCadastrarBanco,
  setModalDeletarBanco,
} = bancoSlice.actions;

export default bancoSlice.reducer;
